import { Injectable, OnInit } from '@angular/core';
import { PeriodsService } from '../mock/periods.service';
import { BehaviorSubject } from 'rxjs';

export class ProfitChart {
  chartLabel: string[];
  data: number[][];
}

@Injectable()
export class ProfitChartService{
  private messageSource = new BehaviorSubject<string>("defaultMessage");
  currentMessage = this.messageSource.asObservable();
  changeToDayOfWeekChart(message: string) {
    this.messageSource.next(message);
  }

  private year = [
    '2012',
    '2013',
    '2014',
    '2015',
    '2016',
    '2017',
    '2018',
  ];

  private data = { };
  //private day :string;
  constructor(private period: PeriodsService) {
    this.data = {
      monday:this.getDataForHours("monday"),
      tuesday:this.getDataForHours("tuesday"),
      wednesday:this.getDataForHours("wednesday"),
      thursday:this.getDataForHours("thursday"),
      friday:this.getDataForHours("friday"),
      saturday:this.getDataForHours("saturday"),
      sunday:this.getDataForHours("sunday"),
      //day: this.getDataForDayPeriod(),
      week: this.getDataForWeekPeriod(),
      month: this.getDataForMonthPeriod(),
      year: this.getDataForYearPeriod(),
    };
  }

  getDataForHours(day: string): ProfitChart {
    const nPoint = this.period.getHours().length;
    let dataArr;
    if(day == "monday"){dataArr = [[181,231,343,323,10,9,8]]}
    if(day == "tuesday"){dataArr =[[154,181,254,455,561,234,231]]}
    if(day == "wednesday"){dataArr =[[8,10,18,45,32,14,10]]}
    if(day == "thursday"){dataArr = [[118,444,541,234,555,789,21]]}
    if(day == "friday"){dataArr = [[431,255,365,412,122,111,10]]}
    if(day == "saturday"){dataArr = [[7,18,17,55,61,45,17]]}
    if(day == "sunday"){dataArr = [[333,451,333,230,124,111,99]]}
    return {
    chartLabel: this.period.getHours(),
    data: dataArr,
  };
}
  private getDataForDayPeriod(): ProfitChart {
    const nPoint = this.period.getDays().length;

    return {
      chartLabel: this.period.getDays(),
      data: [
        this.getRandomData(nPoint),
        this.getRandomData(nPoint),
        this.getRandomData(nPoint),
      ],
    };
  }


  private getDataForWeekPeriod(): ProfitChart {
    const nPoint = this.period.getWeeks().length;

    return {
      chartLabel: this.period.getWeeks(),
      data: [[1105,2070,137,2702,1706,1706,1681]
         ],
    };
  }

  private getDataForMonthPeriod(): ProfitChart {
    const nPoint = this.period.getMonths().length;

    return {
      chartLabel: this.period.getMonths(),
      data: [
        this.getRandomData(nPoint),
        this.getRandomData(nPoint),
        this.getRandomData(nPoint),
      ],
    };
  }

  private getDataForYearPeriod(): ProfitChart {
    const nPoint = this.year.length;

    return {
      chartLabel: this.year,
      data: [
        this.getRandomData(nPoint),
        this.getRandomData(nPoint),
        this.getRandomData(nPoint),
      ],
    };
  }

  private getRandomData(nPoints: number): number[] {
    return Array.from(Array(nPoints)).map(() => {
      return Math.round(Math.random() * 500);
    });
  }

  getProfitChartData(period: string): ProfitChart {
    return this.data[period];
  }
}
